import React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';
import { formatCurrencyNew } from 'utils/helper';
import { useSelector } from 'react-redux';
import PrimaryButton from 'components/Button';
import {

  Box,
} from "@mui/material";
const ProductCard = ({ product }) => {
  
      const webDetails = useSelector(state => state.webDetails);
      const { websiteInfo } = webDetails;
        const variant=product?.variants && product?.variants[0]
    console.log("info", variant)
  const navigate = useNavigate();
  return (
      <Box className="slider-card-mobile" sx={{ padding: "4px" }}>
  
    <Card
  sx={{
    height: "100%",                 
    display: "flex",
    flexDirection: "column",
    borderRadius: "14px",
    border: "1px solid rgba(0,0,0,0.08)",
    boxShadow: "0px 6px 18px rgba(0,0,0,0.08)",
    overflow: "hidden",
    cursor: "pointer",
    transition: "all 0.25s ease",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0px 14px 28px rgba(0,0,0,0.14)",
    },
  }}
  onClick={() => navigate(`/product/${variant?.id}`)}
>
  {/* IMAGE FIXED HEIGHT */}
  <Box sx={{ height: 150, width: "100%" }}>
    <CardMedia
      component="img"
      image={variant?.images?.[0]?.image || variant?.images?.[0]?.image_url}
      alt={product?.name}
      sx={{
        height: "100%",
        width: "100%",
        objectFit: "fill",   // ✅ use only one
      }}
    />
  </Box>

  {/* CONTENT FIXED SPACE */}
  <CardContent
    sx={{
      px: 2,
      pt: 1.5,
      pb: 1,
      flexGrow: 1,  // ✅ important (push button down)
    }}
  >
    <Typography
      sx={{
        fontSize: "0.70rem",
        fontWeight: 400,
         color: "var(--text-muted)",
       
        lineHeight: 1.3,
        minHeight: "32px",  // ✅ fixed space for 2 lines
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
      }}
    >
     {_.truncate(_.trim(product.name), { length: 25 })}
    </Typography>

    <Typography
      sx={{
        fontSize: "0.80rem",
        fontWeight: 550,
        color: "#111",
        mt: 1,
      }}
    >
      {formatCurrencyNew(variant?.price, websiteInfo?.currency_symbol)}
    </Typography>
  </CardContent>

  {/* BUTTON ALWAYS SAME PLACE */}
  <CardActions sx={{ px: 2, pb: 2, pt: 0 }}>
    <Button
      fullWidth
      size="small"
      variant="outlined"
      sx={{
        backgroundColor: "#fff",
        color: "#111",
        border: "1px solid rgba(0,0,0,0.25)",
        borderRadius: "6px",
        fontSize: "0.7rem",
        fontWeight: 500,
        textTransform: "none",
        padding: "6px 10px",
        "&:hover": {
          backgroundColor: "#f4f4f4",
          border: "1px solid rgba(0,0,0,0.4)",
        },
      }}
      onClick={() => navigate(`/product/${variant?.id}`)}
    >
      View
    </Button>
  </CardActions>
</Card>

    </Box>
  );
};

export default ProductCard;
